import { useNavigate } from 'react-router-dom';
import { Snackbar } from 'src/components/snackbar';
import { PATHS } from 'src/constants/paths';
import { useUpdatePublication } from 'src/hooks';
import { lang, useUserRole } from 'src/utils';

import { SimpleDialog } from '../simpleDialog';
import { PublicationModalProps } from './PublicationModal.interface';
import {
  PublicationModalContent,
  PublicationModalTitle,
  PublicationWarningAlert,
  PublishMessageContainer,
  PublishMessageLink,
  PublishMessageText,
} from './PublicationModal.styled';

export const PublicationModal = (props: PublicationModalProps) => {
  const updatePublication = useUpdatePublication();
  const navigate = useNavigate();
  const { isOwnerOperator } = useUserRole();
  const onClickedViewStatus = async () => {
    navigate(PATHS.LIST_PUBLICATIONS);
  };

  const onClickedAddPublication = async () => {
    try {
      props.onPublished?.(true);
      props.onClose();

      Snackbar.info(
        <PublishMessageContainer>
          <PublishMessageText colorType="info" component="span">
            {lang.processPublishing}
          </PublishMessageText>
          {!isOwnerOperator && (
            <PublishMessageLink onClick={onClickedViewStatus} colorType="info">
              {lang.viewStatus}
            </PublishMessageLink>
          )}
        </PublishMessageContainer>,
      );

      await updatePublication.mutateAsync({
        locationCodes: props.locationCodes,
        locationGroupIDs: props.locationGroupIDs,
        publicationType: props.publicationType,
        assemblyIds: props.assemblyIds,
      });
      Snackbar.success(
        <PublishMessageContainer>
          <PublishMessageText component="span">
            {props.publishMessage
              ? props.publishMessage
              : props.successMessage ?? lang.successfullyPublished}
          </PublishMessageText>
          {!isOwnerOperator && (
            <PublishMessageLink onClick={onClickedViewStatus}>
              {lang.viewStatus}
            </PublishMessageLink>
          )}
        </PublishMessageContainer>,
      );
    } catch (error) {
    } finally {
      props.onPublished?.(false);
    }
  };

  return (
    <SimpleDialog
      onClickCancel={() => {
        if (!updatePublication.isLoading) {
          if (props.closeMessage) {
            Snackbar.success(props.closeMessage);
          }
          props.onClose();
        }
      }}
      onClickConfirm={onClickedAddPublication}
      onClose={!updatePublication.isLoading ? props.onClose : () => {}}
      open={props.open}
      title={
        <PublicationModalTitle>
          {props.title ?? lang.publicationModal.title}
        </PublicationModalTitle>
      }
      subTitle={
        <PublicationModalContent>
          {props.alertMessage && (
            <PublicationWarningAlert severity="info">
              {props.alertMessage}
            </PublicationWarningAlert>
          )}
          {props.subTitle ?? lang.publicationModal.subTitle}
        </PublicationModalContent>
      }
      confirmText={props.confirmText ?? lang.publish}
      cancelText={props.cancelText ?? lang.close}
      isLoading={updatePublication.isLoading}
      modalSize={props.modalSize ?? 'sm'}
    />
  );
};
